<div class="clearfix"></div>
<ng-container *ngFor="let key of pages">
    <div class="layout-container layout-padding no-Space_Grid" id="{{key}}">
        <ng-container *ngFor="let col of pageLayout.get(key)">
            <ng-container *ngIf="col.names then complex else simple"></ng-container>    
            <ng-template #simple>
                <div [ngStyle]="{'grid-column-start': col['start'], 'grid-column-end': col['end']}">
                    <app-page-item [type]="col['type']" [name]="col['name']" [input]="col['input']"  ></app-page-item>
                </div>
            </ng-template>
            <ng-template #complex>
                <div [ngStyle]="{'grid-column-start': col['start'], 'grid-column-end': col['end']}">
                    <div class="layout-container layoutMargin">
                        <ng-container *ngFor="let row of col.names">
                            <div [ngStyle]="{'grid-column-start': row['start'], 'grid-column-end': row['end']}">
                                <app-page-item [type]="row['type']" [name]="row['name']" [input]="row['input']"></app-page-item>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-template>
        </ng-container>
    </div>
</ng-container>